export default __webpack_public_path__ + "static/media/home-image@2x.3458e411.jpg";